import React from "react";
import {Popover} from "antd";

const Message = ({
                   message
                 }) => {
  if (message) {
    return (
      <Popover
        placement="left"
        trigger="hover,click,focus"
        content={(
          <>
                <span style={{whiteSpace: 'pre-line'}}>{message}</span>
          </>
        )}
        overlayStyle={{ width: "70vw"}}
      >
        {message}
      </Popover>
    );
  } else {
    return '-';
  }
}

export {Message};